export function navigation() {
    return new Promise((resolve) =>{
        navigator.geolocation.getCurrentPosition(function (position) {
            resolve([position.coords.latitude, position.coords.longitude]);
        }, () => {}, {desiredAccuracy: 1,
            maxWait: 1000
        });
    })
}